import Axios from "axios";
import { REACT_APP_API_ACCOUNTS } from '../../config'

const createAccount = async (data: any) =>{
  
  const account = await Axios.post(
    REACT_APP_API_ACCOUNTS + "/api/AuthControllers/Register",
    // "https://test.accounts.tygo.net/api/AuthControllers/Register",
    data,
  );
  return account;
}

const loginAccount = async (data: any) =>{
  const account = await Axios.post(
    REACT_APP_API_ACCOUNTS + "/api/AuthControllers/Login",
    // "https://test.accounts.tygo.net/api/AuthControllers/Login",
    data,
  );
  return account;
}

const verifyCode = async (number: any, otpType:string, email: string, phoneNumber: string, countryCode: string)=>{
  // const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  const account = await Axios.post(
    REACT_APP_API_ACCOUNTS + "/api/AuthControllers/VerifyCode",
    // "https://test.accounts.tygo.net/api/AuthControllers/VerifyCode",
    {
      "otpCode": number,
      "email": email,
      "phoneNumber": phoneNumber,
      "countryCode": countryCode || "966",
      "deviceToken": "string",
      "otpType": otpType,
      "deviceType": "Web"
    }
  );
  return account;
}

const getProfile = async () => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  const account = await Axios.get(
    REACT_APP_API_ACCOUNTS + "/api/User/GetProfile",
    // "https://test.accounts.tygo.net/api/User/GetProfile",
    {
      headers: {
        'Authorization': `Bearer ${user.token}`
      }
    }
  );
  return account;
}

const updateProfile = async (data: any) => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  const account = await Axios.put(
    REACT_APP_API_ACCOUNTS + "/api/User/UpdateProfile",
    data,
    {
      headers: {
        'Authorization': `Bearer ${user.token}`
      }
    }
  );
  return account;
}
const sendOtpEmail = async (data: any) => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  const account = await Axios.post(
    REACT_APP_API_ACCOUNTS + "/api/User/SendOtpEmail",
    data,
    {
      headers: {
        'Authorization': `Bearer ${user.token}`
      }
    }
  );
  return account;
}
const sendOtpPhoneNumber = async (data: any) => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  const account = await Axios.post(
    REACT_APP_API_ACCOUNTS + "/api/User/SendOtpPhoneNumber",
    data,
    {
      headers: {
        'Authorization': `Bearer ${user.token}`
      }
    }
  );
  return account;
}
const updateEmail = async (data: any) => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  const account = await Axios.put(
    REACT_APP_API_ACCOUNTS + "/api/User/UpdateEmail",
    data,
    {
      headers: {
        'Authorization': `Bearer ${user.token}`
      }
    }
  );
  return account;
}
const updatePhoneNumber = async (data: any) => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  const account = await Axios.put(
    REACT_APP_API_ACCOUNTS + "/api/User/UpdatePhoneNumber",
    data,
    {
      headers: {
        'Authorization': `Bearer ${user.token}`
      }
    }
  );
  return account;
}




const Logout = async (navigation: any) => {
  localStorage.removeItem('tygo_user');
  navigation('/login');
}


export {
  createAccount,
  loginAccount,
  verifyCode,
  Logout,
  getProfile,
  updateProfile,
  sendOtpEmail,
  sendOtpPhoneNumber,
  updateEmail,
  updatePhoneNumber
};